export default __webpack_public_path__ + "static/media/paint-bucket.cc7dbea7.png";